import "./Exchange.scss";
import "../../common/Mobilenav/MobilenavStyle.scss";
import { useAppSelector, useIsLoggedSelector } from "../../../services/hooks.service";
import { DelistingWarn, MaintenanceWarn, PreSaleWarn, SheduledModeWarn } from "../../common";
import { MaintenanceMode } from "../../../interfaces/settings.interfase";
import { useState, useEffect } from "react";
import { equalsIgnoreCase } from "../../../_utils";
import { initialSystemMaintenanceState, initialUserOrdersArrayState, useGetMaintenanceQuery, useGetOrdersQuery } from "@ultrade/react-sdk";
import { OrderExecution, OrderExecutionType } from "@ultrade/ultrade-js-sdk";
import { ORDER_LIMIT } from "../../../constants/constants";

export const MaintenanceBanners = () => {
  // const scheduledDate = useAppSelector((state) => state.system.scheduledDate);
  // const m_mode = useAppSelector((state) => state.system.maintenance_mode);
  const { data: {maintenance_mode, scheduledDate} = initialSystemMaintenanceState } = useGetMaintenanceQuery();
  const [showMode, setShowMode] = useState(true);

  return (
    <div className="warning_wrapper">
      { maintenance_mode === MaintenanceMode.Scheduled && showMode &&
        <SheduledModeWarn date={scheduledDate} hide={setShowMode} /> 
      }

      { maintenance_mode === MaintenanceMode.Partial && 
        <MaintenanceWarn /> 
      }
    </div>
  );
}

export const TradeBanners = () => {
  const checkedPresalePairsId = useAppSelector((state) => state.persist.presalePairChecked);
  const checkedDelistedPairsId = useAppSelector((state) => state.persist.delistedPairsChecked);
  const isLogged = useIsLoggedSelector();
  // const userOrders = useAppSelector((state) => state.exchange.userOrders.open);
  const selectedPair = useAppSelector((state) => state.user.selectedPair);
  const mainAddress = useAppSelector((state) => state.user.mainAddress);


  const { data: { open: userOrders } = initialUserOrdersArrayState } = useGetOrdersQuery({ status: OrderExecution.open, symbol: selectedPair?.pair_key, limit: ORDER_LIMIT, orderHistoryTab: OrderExecutionType.open }, {
    skip: !isLogged,
    refetchOnMountOrArgChange: true,
  });

  return (
    <div className="warning_wrapper">
      
      { selectedPair.delisting_date && !checkedDelistedPairsId.some(e => e === selectedPair.id)
       && userOrders.some(o => o.pairId === selectedPair.id) &&
        <DelistingWarn pair={selectedPair} /> 
      }

      { selectedPair.pairSettings?.preSaleMode && !checkedPresalePairsId.some(e => e === selectedPair.id) &&
        !equalsIgnoreCase(selectedPair.pairSettings?.preSaleMode?.sellerAddress, mainAddress) && 
        <PreSaleWarn pair={selectedPair} /> 
      }
    </div>
  );
}